export default "__VITE_ASSET__D7Kf1Jam__"